// @ts-ignore
import { unRemask } from "../../../../../libs/remask-mask";

interface SearchConfig {
  initialCase: number;
  value: any;
  list: any[];
  cases: string[];
}

export default function searchTheEntireList({
  initialCase,
  cases,
  list,
  value,
}: SearchConfig) {
  const sanitizeValue = cases[initialCase] === "CPF" || cases[initialCase] === "RG" ? unRemask(value) : value;
  let filterList: any[] = [];
  return filterLists();
  function filterLists() {
    // for (let count = 0; count < 7; count++) {
    filterList = list?.filter((filterRow: any) => {
      if (initialCase === 5 || initialCase === 6)
        return filterRow[cases[initialCase]]?.map((item) => item?.toLowerCase())?.includes(sanitizeValue?.toLowerCase());
      if (initialCase <= cases?.length) return Boolean(filterRow[cases[initialCase]]?.toLowerCase()?.includes(sanitizeValue?.toLowerCase()));

      filterList = filterRow[cases[initialCase]]?.map((item: string) => {
        return item?.toLowerCase()?.includes(sanitizeValue?.toLowerCase());
      });
      return isEmpyValue() ? cleanList(list) : cleanList(filterList);
    });

    listIsNotEmpty() && (initialCase = 7);
    // }
    return filterList;
  }

  function isEmpyValue() {
    return value?.length === 0;
  }

  function cleanList(array: any[]) {
    const result = array.filter(Boolean);
    return result?.length ? result[0] : false;
  }

  function listIsNotEmpty() {
    return filterList?.length ? true : false;
  }
}
